/* import __COLOCATED_TEMPLATE__ from './signup-button.hbs'; */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';

/** @type {string} */
const CLASSNAME = 'signup-button';

/** @module */
const SignupButton = Component.extend({
  /** @inheritDoc */
  tagName: 'button',

  /** @inheritDoc */
  classNames: [CLASSNAME],

  /** @inheritDoc */
  classNameBindings: [
    `isSecondary:${CLASSNAME}--secondary`,
    `isTertiary:${CLASSNAME}--tertiary`,
    `fullWidth:${CLASSNAME}--full-width`,
  ],

  /** @inheritDoc */
  attributeBindings: [
    'disabled',
    'type',
    'style',
  ],

  /** @type {string} */
  role: 'primary',

  /** @type {Ember.ComputedProperty} */
  isSecondary: equal('role', 'secondary'),

  /** @type {Ember.ComputedProperty} */
  isTertiary: equal('role', 'tertiary'),

  /** @param {Function|undefined} */
  action: undefined,

  /** @param {String} */
  text: '',

  click() {
    const action = this.get('action');

    if (typeof action === 'function') {
      action();
    }
  },
});

export default SignupButton;
